export default __webpack_public_path__ + "static/media/icn-delivery.a485c953.svg";